module.exports = __webpack_public_path__ + "static/media/digital-marketing.f75e2d6f.svg";